import { removeItemApi } from "../../../api/cartService";
import { IconGift } from "../../../components/atoms/iconGift.js";

export function Product(props) {
  const { product, loader, refetch } = props;

  const removeItem = async (item) => {
    loader(true);
    const { totals } = await removeItemApi(item.keyCart);
    const res = await refetch();
    if (res.totals && totals) {
      loader(false);
    }
  };
  return (
    <>
      <div className="flex w-full lg:h-auto h-[105px] pb-5">
        <div className="lg:w-[100px] lg:max-h-[100px] w-[56px] h-max-[56px] relative">
          <div className="absolute -right-2 -top-2 h-[22px] z-10 w-[22px] text-white text-[15px] font-bold rounded-full bg-[#5F6E79] text-center">
            {product.qty}
          </div>
          <div className="aspect-w-1 aspect-h-1 border border-[#5F6E79] bg-white">
            <img
              src={product.img.mini}
              alt={product.name}
              className="object-cover"
            />
          </div>
        </div>
        <div className="flex flex-col flex-grow pl-4">
          <a href={product.url} className="font-semibold text-[#5F6E79]">
            {product.title}
          </a>
          <p className="text-sm flex-grow text-[#8B99A5]">{product.subtitle}</p>
          {product.isDiscount ? (
            <>
              <div className="space-x-4">
                <span className="pt-1 font-bold text-[#5F6E79]">
                  {product.price.format}
                </span>
                <span className="pt-1 text-sm line-through text-[#8B99A5]">
                  {product.originalPrice.format}
                </span>
              </div>
            </>
          ) : (
            <p className="pt-1 font-bold text-[#5F6E79]">
              {product.price.format}
            </p>
          )}
        </div>
        <button
          className="h-10 hover:text-red-600 inline-flex items-center justify-center text-[#5F6E79] w-10"
          onClick={() => {
            removeItem(product);
          }}
        >
          <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8.0013 0.458008C8.69308 0.457963 9.35866 0.722636 9.8615 1.19773C10.3643 1.67283 10.6663 2.32234 10.7055 3.01301L10.7096 3.16634H15.0846C15.243 3.16639 15.3954 3.22654 15.5111 3.33465C15.6268 3.44276 15.6972 3.59076 15.708 3.74874C15.7188 3.90673 15.6692 4.06292 15.5693 4.18576C15.4693 4.3086 15.3265 4.38892 15.1696 4.41051L15.0846 4.41634H14.4213L13.3546 15.2663C13.3012 15.8073 13.0572 16.3116 12.6663 16.6892C12.2754 17.0669 11.7629 17.2933 11.2205 17.328L11.0738 17.333H4.9288C4.38502 17.333 3.85896 17.1396 3.44464 16.7874C3.03032 16.4352 2.75473 15.9472 2.66714 15.4105L2.64797 15.2655L1.58047 4.41634H0.917969C0.766937 4.41633 0.621017 4.36164 0.507193 4.26237C0.393369 4.1631 0.319342 4.02597 0.298802 3.87634L0.292969 3.79134C0.292975 3.64031 0.347671 3.49439 0.446941 3.38057C0.546212 3.26674 0.683341 3.19271 0.832969 3.17217L0.917969 3.16634H5.29297C5.29297 2.44805 5.57831 1.75917 6.08622 1.25126C6.59413 0.743349 7.28301 0.458008 8.0013 0.458008ZM13.1655 4.41634H2.8363L3.89214 15.143C3.91551 15.3824 4.02099 15.6062 4.19066 15.7767C4.36032 15.9471 4.58373 16.0536 4.82297 16.078L4.9288 16.083H11.0738C11.5738 16.083 11.998 15.7288 12.0946 15.248L12.1113 15.143L13.1646 4.41634H13.1655ZM9.45964 6.70801C9.61067 6.70801 9.75659 6.76271 9.87041 6.86198C9.98423 6.96125 10.0583 7.09838 10.0788 7.24801L10.0846 7.33301V13.1663C10.0846 13.3247 10.0244 13.4771 9.91632 13.5928C9.80822 13.7085 9.66022 13.7789 9.50224 13.7897C9.34425 13.8005 9.18806 13.7509 9.06522 13.651C8.94238 13.551 8.86205 13.4082 8.84047 13.2513L8.83464 13.1663V7.33301C8.83464 7.16725 8.90048 7.00828 9.01769 6.89107C9.1349 6.77386 9.29388 6.70801 9.45964 6.70801ZM6.54297 6.70801C6.694 6.70801 6.83992 6.76271 6.95374 6.86198C7.06757 6.96125 7.1416 7.09838 7.16214 7.24801L7.16797 7.33301V13.1663C7.16792 13.3247 7.10777 13.4771 6.99966 13.5928C6.89155 13.7085 6.74355 13.7789 6.58557 13.7897C6.42758 13.8005 6.27139 13.7509 6.14855 13.651C6.02571 13.551 5.94539 13.4082 5.9238 13.2513L5.91797 13.1663V7.33301C5.91797 7.16725 5.98382 7.00828 6.10103 6.89107C6.21824 6.77386 6.37721 6.70801 6.54297 6.70801ZM8.0013 1.70801C7.63531 1.70802 7.2827 1.84565 7.01348 2.09357C6.74425 2.3415 6.57808 2.68159 6.54797 3.04634L6.54297 3.16634H9.45964C9.45964 2.77957 9.30599 2.40863 9.0325 2.13514C8.75901 1.86165 8.38808 1.70801 8.0013 1.70801Z" />
          </svg>
        </button>
      </div>
      {product.present.length ? (
        <div className="flex items-center py-3 mt-2">
          <div className="inline-flex justify-center w-[60px]">
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0V6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13H12.17L9.08 16.09L10.5 17.5L16 12L10.5 6.5L9.09 7.91L12.17 11H6.5C4 11 2 9 2 6.5V0H0Z"
                fill="#5F6E79"
              />
            </svg>
          </div>
          <img
            alt={product.present.name}
            className="bg-white border border-[#5F6E79] w-[60px]"
            src={product.present.ico.mini}
          />
          <div className="ml-2">
            <p className="font-semibold text-[#5F6E79]">
              {product.present.title}
            </p>
            <div className="flex items-center">
              <span className="pt-1 font-bold text-[#5F6E79]">
                {product.present.prod_price_form}{" "}
              </span>
              <i className="inline-flex ml-2">
                <IconGift />
              </i>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
